<ngb-toast *ngFor="let toast of toastService.toasts" [class]="toast.classname + ' bottom-0'" [autohide]="true"
  [delay]="toast.delay || 10000" (click)="toastService.remove(toast)"
  style="min-width: 350px; max-width: 450px; width: auto; height: auto; padding: 0.75rem 1rem;">

  <ng-template [ngIf]=" toast.template == 'error'">
    <div class="toast-body" style="padding: 0; display: flex; align-items: flex-start; gap: 10px;">
      <fa-icon class="icon" [icon]="iconError" style="flex-shrink: 0; margin-top: 3px;"></fa-icon>
      <span style="color: white; white-space: pre-line; line-height: 1.4; font-size: 0.9rem;">{{ toast.message }}</span>
    </div>
  </ng-template>

  <ng-template [ngIf]=" toast.template == 'success'">
    <div class="toast-body" style="padding: 0; display: flex; align-items: flex-start; gap: 10px;">
      <fa-icon class="icon" [icon]="iconSuccess" style="flex-shrink: 0; margin-top: 3px;"></fa-icon>
      <span style="color: white; white-space: pre-line; line-height: 1.4; font-size: 0.9rem;">{{ toast.message }}</span>
    </div>
  </ng-template>

  <ng-template [ngIf]=" toast.template == 'warning'">
    <div class="toast-body" style="padding: 0; display: flex; align-items: flex-start; gap: 10px;">
      <fa-icon class="icon" [icon]="iconWarning" style="flex-shrink: 0; margin-top: 3px;"></fa-icon>
      <span style="color: white; white-space: pre-line; line-height: 1.4; font-size: 0.9rem;">{{ toast.message }}</span>
    </div>
  </ng-template>

  <ng-template [ngIf]=" toast.template == 'info'">
    <div class="toast-body" style="padding: 0; display: flex; align-items: flex-start; gap: 10px;">
      <fa-icon class="icon" [icon]="iconInfo" style="flex-shrink: 0; margin-top: 3px;"></fa-icon>
      <span style="color: white; white-space: pre-line; line-height: 1.4; font-size: 0.9rem;">{{ toast.message }}</span>
    </div>
  </ng-template>
</ngb-toast>